import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/header.css'
import './assets/css/footer.css'
import './assets/css/variable.css'


createApp(App)
  .use(router)
  .mount('#app')